// assets
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import DomainIcon from '@mui/icons-material/Domain';
import ReceiptIcon from '@mui/icons-material/Receipt';

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const utilities = {
    id: 'utilities',
    title: 'Pages',
    type: 'group',
    children: [
        {
            id: 'invoice',
            title: 'Invoice Generate',
            type: 'item',
            url: '/admin/invoice',
            icon: ReceiptIcon,
            breadcrumbs: false
        },
        {
            id: 'invoice-setting',
            title: 'Invoice Setting',
            type: 'item',
            url: '/admin/invoice-setting',
            icon: SettingsApplicationsIcon,
            breadcrumbs: false
        },
        {
            id: 'domain-hosting',
            title: 'Domain Hosting Management',
            type: 'item',
            url: '/admin/domain-hosting',
            icon: DomainIcon,
            breadcrumbs: false
        },
    ]
};

export default utilities;